export type CancellationReason = {
  id?: string;
  value: string;
  needs_doc?: boolean;
};

export enum CancelRequestStatus {
  UNDEFINED,
  SUCCESS,
  FAILED,
}
export interface IOrder {
  info: any;
  cancellationReasons: CancellationReason[];
  selectedCancelReason?: CancellationReason;
  cancellRequestStatus: CancelRequestStatus;
  changesRequestStatus: CancelRequestStatus;
  changes: any;
  customReasonText: string;
  changesTouristsRequestStatus: CancelRequestStatus;
}
